module.exports = __webpack_public_path__ + "media/images/illustrations/storage_facility-3b19306c032bca332ca50656211a35ae.svg";